<div class="dialog-container" [style]="getDialogContainerStyles()">
  <div class="title-bar">
    <div class="title">{{data.title}}</div>
    <mat-progress-spinner *ngIf="working" class="spinner" color="primary" mode="indeterminate" diameter="21">
    </mat-progress-spinner>
  </div>
  <span *ngIf="data.body" class="text">{{data.body}}</span>
  <div class="input-container">
    <input *ngIf="!data.number" type="text" class="input" [ngClass]="{error: error}" [disabled]="working"
      [placeholder]="data.placeholder" [(ngModel)]="value" (keydown.enter)="submit()" />
    <input numberInput *ngIf="data.number" type="text" class="input" [ngClass]="{error: error}" [disabled]="working"
      [placeholder]="data.placeholder" [(ngModel)]="value" (keydown.enter)="submit()" />
    <span *ngIf="error" class="error-text">{{error}}</span>
  </div>
  <div class="buttons">
    <button mat-button class="text-button" *ngFor="let button of data.buttons" [ngClass]="button.class"
      [disabled]="working || (error && button.disableIfError) || !likesValue(button)" (click)="handleClick(button)">
      {{button.text}}
    </button>
  </div>
</div>